// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ModelSvg from '@rsuite/icon-font/lib/application/Model';
var Model = createSvgIcon({
  as: ModelSvg,
  ariaLabel: 'model',
  category: 'application',
  displayName: 'Model'
});
export default Model;